import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import Text from '../Text';
import AnimationComponent from '../../Component/Animation';
import TextBoundaryComponent from '../../Component/TextBoundary';
import * as PIXI from 'pixi.js';

export default class SpeechBubble extends GameObject {
    protected onCreate(params: {
        x: number;
        y: number;
        text: string;
        textStyle: PIXI.TextStyleOptions;
        visible?: boolean;
    }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'stargate_cloud',
            anchor: new Point(0.5, 1),
        });

        this.addChild(baseSprite);

        // Add the message.
        const message: Text = GameObject.Instantiate(Text, {
            position: new Point(0, -65),
            anchor: new Point(0.5, 0.5),
            text: params.text,
            style: params.textStyle,
        });

        message.addComponent<TextBoundaryComponent>(TextBoundaryComponent, {
            bounds: new Point(170, 70),
        });

        this.addChild(message);

        // Animate.
        this.addComponent(AnimationComponent, {
            playOnStart: false,
            clipName: 'SpeechBubblePopUp',
        });
    }
}
